import { tidy } from '@aera/ui';
import { fresh, type AnswerProps } from './common.js';

/** 1–5 with labelled ends, as one row of five segments. */
export function ScaleQuestion({ rq, value, onChange }: AnswerProps) {
  return (
    <div>
      <div role="radiogroup" aria-labelledby={`q-${rq.id}-label`} className="grid grid-cols-5 gap-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            id={`opt-${rq.id}-${n}`}
            type="button"
            role="radio"
            aria-checked={value.scale === n}
            aria-label={n === 1 ? `1 · ${rq.scale?.minLabel ?? ''}` : n === 5 ? `5 · ${rq.scale?.maxLabel ?? ''}` : String(n)}
            onClick={() => onChange({ ...fresh(value), scale: n })}
            className="option-card flex h-14 items-center justify-center rounded-2xl border border-hair bg-white text-[18px] font-medium tabular-nums"
          >
            {n}
          </button>
        ))}
      </div>
      {rq.scale && (
        <div className="mt-3 flex justify-between gap-6 text-[14px] leading-snug text-ink-2">
          <span className="max-w-[45%]">1 = {tidy(rq.scale.minLabel)}</span>
          <span className="max-w-[45%] text-right">5 = {tidy(rq.scale.maxLabel)}</span>
        </div>
      )}
    </div>
  );
}
